import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useNotificationStore } from "@/entities/notification";

/**
 * Thin reactive view over the notification store for UI components.
 * Exposes the imperative surface used by the drawer panel.
 */
export function useNotificationsList() {
  const store = useNotificationStore();
  const {
    items,
    groupedByDate,
    categories,
    unread,
    unreadByCategory,
    filters,
    pagination,
    loading,
    loadingMore,
    markingAll,
    error,
    expandedUid,
    detailsCache,
    isEmpty,
  } = storeToRefs(store);

  const activeCategory = computed({
    get() {
      return store.filters.categories?.[0] || "all";
    },
    set(key) {
      store.setFilters({ categories: key && key !== "all" ? [key] : [] });
    },
  });

  const hasMore = computed(() => pagination.value.hasMore);

  return {
    // state
    items,
    groupedByDate,
    categories,
    unread,
    unreadByCategory,
    filters,
    loading,
    loadingMore,
    markingAll,
    error,
    expandedUid,
    detailsCache,
    isEmpty,
    hasMore,
    activeCategory,

    // actions
    refresh: () => store.fetchList({ append: false }),
    loadMore: () => store.loadMore(),
    markRead: (eventUuid) => store.markRead(eventUuid),
    markAllRead: () => store.markAllRead(),
    toggleExpand: (uid) => store.setExpanded(uid),
    setFilters: (partial) => store.setFilters(partial),
    resetFilters: () => store.resetFilters(),
    fetchCategories: () => store.fetchCategories(),
    fetchCounter: () => store.fetchCounter(),
  };
}
